import { render, staticRenderFns } from "./ShowInfo.vue?vue&type=template&id=5b29719a&scoped=true&"
import script from "./ShowInfo.vue?vue&type=script&lang=js&"
export * from "./ShowInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowInfo.vue?vue&type=style&index=0&id=5b29719a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29719a",
  null
  
)

export default component.exports